import { render, staticRenderFns } from "./AddViewportDialog.vue?vue&type=template&id=28497894&scoped=true"
import script from "./AddViewportDialog.vue?vue&type=script&lang=js"
export * from "./AddViewportDialog.vue?vue&type=script&lang=js"
import style0 from "./AddViewportDialog.vue?vue&type=style&index=0&id=28497894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28497894",
  null
  
)

export default component.exports